import AzureActiveDirectoryIcon from '@asset/service-icons/azure-active-directory.icon.svg?react';
import BamboohrIcon from '@asset/service-icons/bamboohr.icon.svg?react';
import BringIcon from '@asset/service-icons/bring.icon.svg?react';
import CatalystOneIcon from '@asset/service-icons/catalyst-one.icon.svg?react';
import DeelIcon from '@asset/service-icons/deel.icon.svg?react';
import DustinIcon from '@asset/service-icons/dustin.icon.svg?react';
import FedexIcon from '@asset/service-icons/fedex.icon.svg?react';
import GithubIcon from '@asset/service-icons/github.icon.svg?react';
import GoogleWorkspaceIcon from '@asset/service-icons/google-workspace.icon.svg?react';
import HaileyHRIcon from '@asset/service-icons/haileyhr.icon.svg?react';
import HexnodeIcon from '@asset/service-icons/hexnode.icon.svg?react';
import HibobIcon from '@asset/service-icons/hibob.icon.svg?react';
import IngramIcon from '@asset/service-icons/ingram-micro.icon.svg?react';
import InregoIcon from '@asset/service-icons/inrego.icon.svg?react';
import JamfIcon from '@asset/service-icons/jamf.icon.svg?react';
import KandjiIcon from '@asset/service-icons/kandji.icon.svg?react';
import MicrosoftIntuneIcon from '@asset/service-icons/microsoft-intune.svg?react';
import NetsetIcon from '@asset/service-icons/netset.icon.svg?react';
import PostiIcon from '@asset/service-icons/posti.icon.svg?react';
import PostnordIcon from '@asset/service-icons/postnord.icon.svg?react';
import ServiceNowIcon from '@asset/service-icons/service-now.icon.svg?react';
import TeamtailorIcon from '@asset/service-icons/teamtailor.icon.svg?react';
import VeloryIcon from '@asset/service-icons/velory.icon.svg?react';
import WebmercsIcon from '@asset/service-icons/webmercs.icon.svg?react';
import { ConnectorServiceEnum } from '@enum/connector-service.enum';
import { isExist } from '@util/data/is-exist';

/* eslint-disable @typescript-eslint/naming-convention */
const ICON_LIST = {
  [ConnectorServiceEnum.AzureActiveDirectory]: AzureActiveDirectoryIcon,
  [ConnectorServiceEnum.AzureOidc]: AzureActiveDirectoryIcon,
  [ConnectorServiceEnum.AzureSaml]: AzureActiveDirectoryIcon,
  [ConnectorServiceEnum.BambooHR]: BamboohrIcon,
  [ConnectorServiceEnum.Bring]: BringIcon,
  [ConnectorServiceEnum.CatalystOne]: CatalystOneIcon,
  [ConnectorServiceEnum.Deel]: DeelIcon,
  [ConnectorServiceEnum.Dustin]: DustinIcon,
  [ConnectorServiceEnum.Fedex]: FedexIcon,
  [ConnectorServiceEnum.GithubOidc]: GithubIcon,
  [ConnectorServiceEnum.GoogleDevices]: GoogleWorkspaceIcon,
  [ConnectorServiceEnum.GoogleOidc]: GoogleWorkspaceIcon,
  [ConnectorServiceEnum.GoogleSaml]: GoogleWorkspaceIcon,
  [ConnectorServiceEnum.GoogleWorkspace]: GoogleWorkspaceIcon,
  [ConnectorServiceEnum.HaileyHR]: HaileyHRIcon,
  [ConnectorServiceEnum.Hexnode]: HexnodeIcon,
  [ConnectorServiceEnum.Hibob]: HibobIcon,
  [ConnectorServiceEnum.Ingram]: IngramIcon,
  [ConnectorServiceEnum.Inrego]: InregoIcon,
  [ConnectorServiceEnum.Jamf]: JamfIcon,
  [ConnectorServiceEnum.Kandji]: KandjiIcon,
  [ConnectorServiceEnum.MicrosoftIntune]: MicrosoftIntuneIcon,
  [ConnectorServiceEnum.Netset]: NetsetIcon,
  [ConnectorServiceEnum.Posti]: PostiIcon,
  [ConnectorServiceEnum.Postnord]: PostnordIcon,
  [ConnectorServiceEnum.ServiceNow]: ServiceNowIcon,
  [ConnectorServiceEnum.Teamtailor]: TeamtailorIcon,
  [ConnectorServiceEnum.Velory]: VeloryIcon,
  [ConnectorServiceEnum.Webmercs]: WebmercsIcon,
};

interface ServiceIconProps {
  icon: ConnectorServiceEnum;
  width?: number | string;
  height?: number | string;
}

export const ServiceIcon = ({ icon, width = '100%', height = '100%' }: ServiceIconProps) => {
  const IconComponent = ICON_LIST[icon];
  return isExist(IconComponent) && <IconComponent height={height} width={width} />;
};
